import React from 'react'

const Status503 = () => {
  return (
    <div>
      <h1>503 Service Unavailable</h1>
    </div>
  )
}

export default Status503
